import { useEffect, useState } from 'react';
import Modal from './Modal';

export default function InactivityWarningModal({ isOpen, onStayLoggedIn, onLogout }) {
  const [secondsLeft, setSecondsLeft] = useState(120);

  useEffect(() => {
    if (!isOpen) { setSecondsLeft(120); return; }
    setSecondsLeft(120);
    const interval = setInterval(() => {
      setSecondsLeft((s) => {
        if (s <= 1) { clearInterval(interval); return 0; }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [isOpen]);

  const mins = Math.floor(secondsLeft / 60);
  const secs = String(secondsLeft % 60).padStart(2, '0');

  return (
    <Modal isOpen={isOpen} onClose={onStayLoggedIn} title="Session expiring soon" size="sm">
      <p className="text-sm text-neutral-600 dark:text-neutral-400 mb-2">
        You&apos;ve been inactive for a while. For security, you&apos;ll be logged out automatically in:
      </p>
      <p className="text-3xl font-bold text-center text-primary-600 dark:text-primary-400 my-4">
        {mins}:{secs}
      </p>
      <div className="flex justify-end gap-3 mt-4">
        <button onClick={onLogout} className="btn btn-secondary">
          Log out now
        </button>
        <button onClick={onStayLoggedIn} className="btn btn-primary">
          Stay logged in
        </button>
      </div>
    </Modal>
  );
}
